<template>
  <v-card class="pa-6 manage-config-visualmanagement">
    <div class="mb-2"><b>{{ $t('APPEARANCE.PALETTE') }}</b></div>
    <btn-toggle-filter v-model="palette" mandatory="force" variant="outlined" density="compact">
      <v-btn value="">
        <v-icon start>far fa-balance-scale</v-icon>{{ $t('APPEARANCE.PALETTE_DEFAULT') }}
      </v-btn>
      <v-btn value="pastel">
        <v-icon start>far fa-paint-brush-alt</v-icon>{{ $t('APPEARANCE.PALETTE_PASTEL') }}
      </v-btn>
      <v-btn value="contrasted">
        <v-icon start>far fa-adjust</v-icon>{{ $t('APPEARANCE.PALETTE_CONTRASTED') }}
      </v-btn>
    </btn-toggle-filter>
    <div :class="`colors-${palette}`" class="mt-2 color-picker px-2" style="max-width: 378px">
      <color-picker-color :color="0" :color-shade="0" :target="dummyElement" :planning="dummyPlanning" :compact="! editLabels"></color-picker-color>
    </div>
    <v-switch v-model="editLabels" :label="$t('APPEARANCE.SHOW_CUSTOM_LABELS')" class="mt-2"></v-switch>
  </v-card>
</template>

<style lang="scss">
  .manage-config-visualmanagement {
    .color-picker .color-square {
      cursor: default !important;

      .fa-check {
        display: none !important;
      }
    }
  }
</style>

<script>
  import Planning from '@/models/Planning';
  import PlanningElement from '@/models/PlanningElement';
  import useUsersAccessRightStore from '@/stores/users/accessRight';
  import ColorPickerColor from '@/components/ColorPicker/ColorPickerColor.vue';

  export default {
    components: {
      ColorPickerColor,
    },
    data() {
      return {
        dummyPlanning: new Planning(),
        dummyElement: new PlanningElement(),
        editLabels: false,
      };
    },
    computed: {
      palette: {
        get() {
          return this.computedConfig.themePalette || '';
        },
        set(newVal) {
          const oldVal = this.palette;
          if (oldVal) document.body.classList.remove(`colors-${oldVal}`);
          this.setParam('themePalette', newVal);
          if (newVal) document.body.classList.add(`colors-${newVal}`);
        },
      },
      computedConfig() {
        return useUsersAccessRightStore().config;
      },
    },
    created() {
      if (this.hasColorsConfig(this.dummyPlanning.config.colors)) this.editLabels = true;

      this.debounceSetColors = _.debounce(function (newVal) {
        this.setParam('colors', this.hasColorsConfig(newVal) ? newVal : null);
      }, 3000);
    },
    watch: {
      'dummyPlanning.config.colors': {
        handler(newVal) {
          this.debounceSetColors(newVal);
        },
        deep: true,
      },
    },
    methods: {
      hasColorsConfig(colors) {
        return colors.some(item => item.label || item.sublabels?.some(subitem => subitem));
      },
      setParam(prop, val) {
        useUsersAccessRightStore().updateBusinessConfig({ [prop]: val });
      },
    },
  };
</script>
